import React, { useState } from "react";
import { MenuItem, Select } from "@mui/material";
import "./renewal-rate-summary.scss";
import { MUITable } from "../../../../common/components";
import { renewalRateSummaryHeaders } from "./renewal-rate-summary.constant";

const RenewalRateSummary = (props: any) => {
  const { RenewalRateSummaryData, handleAddSubscriptionReports, enableExport } = props;
  const [fileFormat, setFileFormat] = useState<any>("pdf");

  const handleExport = async () => {
    try {
      handleAddSubscriptionReports(
        { imageData: "" },
        { section: "subscription-renewal-rate-summary", format: fileFormat }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };

  return (
    <div className="subscription-report-renewal-rate-summary-card">
      <div className="subscription-report-renewal-rate-summary-card-header">
        <div className="subscription-report-renewal-rate-summary-card-header-title">
          Renewal Rate Summary
        </div>
        <div className="subscription-report-renewal-rate-summary-card-header-sub-title">
          <div className="subscription-report-renewal-rate-summary-card-header-sub-title-sub-icon">
            <div className="subscription-report-renewal-rate-summary-card-header-sub-title-icon"></div>
            <div className="subscription-report-renewal-rate-summary-card-header-sub-title-sub-icon-text">
              Grace Period
            </div>
          </div>
          <div className="subscription-report-renewal-rate-summary-card-header-sub-title-buttons-dropdown">
            <Select
              value={fileFormat}
              onChange={(e) => setFileFormat(e.target.value)}
              size="small"
            >
              <MenuItem
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#2684FF",
                    color: "#fff",
                    borderRadius: "0px !important",
                    ":hover": {
                      backgroundColor: "#2684FF !important",
                    }
                  },
                }}
                value="pdf"
              >
                PDF
              </MenuItem>
              <MenuItem
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#2684FF",
                    color: "#fff",
                    borderRadius: "0px !important",
                    ":hover": {
                      backgroundColor: "#2684FF !important",
                    }
                  },
                }}
                value="csv"
              >
                CSV
              </MenuItem>
            </Select>
            <button
              className="subscription-report-renewal-rate-summary-card-header-sub-title-buttons-dropdown-button"
              onClick={handleExport}
              disabled={!enableExport}
            >
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="subscription-report-renewal-rate-summary-card-chart">
        <MUITable
          headers={renewalRateSummaryHeaders}
          data={RenewalRateSummaryData}
          isStriped={false}
          rowClassName="panding-steps-column"
        />
      </div>
    </div>
  );
};

export default RenewalRateSummary;
